import { render, staticRenderFns } from "./SampleCertificateBlankFileSave.vue?vue&type=template&id=52268eb0&scoped=true&"
import script from "./SampleCertificateBlankFileSave.vue?vue&type=script&lang=js&"
export * from "./SampleCertificateBlankFileSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52268eb0",
  null
  
)

export default component.exports